(function () {
  if (window.TexanSleepSystemReady) return;
  window.TexanSleepSystemReady = true;

  function parseJson(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return [];
    }
  }

  function normalizeSize(value) {
    var size = String(value || "").toLowerCase().replace(/×/g, "x").replace(/[–—]/g, "-").trim();
    if (!size) return null;
    if (/rv\b|olympic|short\s*queen|alaskan|wyoming|texas\s*king/.test(size)) return null;
    if (/split\s*(head|top)|flex\s*head/.test(size)) {
      if (/(california|cal\.?|ca)\s*king/.test(size)) return "split_head_cal_king";
      if (/king/.test(size)) return "split_head_king";
      if (/queen/.test(size)) return "split_head_queen";
      return null;
    }
    if (/split/.test(size) && /(california|cal\.?|ca)\s*king/.test(size)) return "split_ca_king";
    if (/split/.test(size) && /king/.test(size)) return "split_king";
    if (/split/.test(size) && /queen/.test(size)) return null;
    if (/full\s*(xl|extra\s*long)/.test(size)) return null;
    if (/twin\s*(xl|x-?long|extra\s*long|long)/.test(size) || /\btxl\b/.test(size)) return "twin_xl";
    if (/(california|cal\.?|ca)\s*king/.test(size)) return "cal_king";
    if (/\btwin\b/.test(size)) return "twin";
    if (/\bfull\b|\bdouble\b/.test(size)) return "full";
    if (/\bqueen\b/.test(size)) return "queen";
    if (/\bking\b/.test(size)) return "king";
    return null;
  }

  function displaySize(key) {
    var labels = {
      twin: "Twin",
      split_head_queen: "Split Head Queen",
      split_head_king: "Split Head King",
      split_head_cal_king: "Split Head California King",
      twin_xl: "Twin XL",
      full: "Full",
      queen: "Queen",
      king: "King",
      cal_king: "Cal King",
      split_king: "Split King",
      split_ca_king: "Split CA King"
    };
    return labels[key] || "";
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || "USD",
        maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return "$" + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function replaceToken(template, token, value) {
    return String(template || "").split(token).join(value);
  }

  function currentVariant(root, variants, idInput) {
    var id = String(idInput && idInput.value || "");
    return variants.find(function (variant) {
      return String(variant.id) === id;
    }) || null;
  }

  function sizeFromVariant(root, variant) {
    if (!variant) return { key: null, raw: "" };
    var index = Number(root.dataset.sizeOptionIndex);
    if (index >= 0 && variant.options && variant.options[index] != null) {
      return { key: normalizeSize(variant.options[index]), raw: String(variant.options[index]) };
    }
    var raw = "";
    var key = null;
    (variant.options || []).some(function (option) {
      var normalized = normalizeSize(option);
      if (!normalized) return false;
      raw = String(option);
      key = normalized;
      return true;
    });
    return { key: key, raw: raw };
  }

  function setChoiceState(root) {
    root.querySelectorAll(".tx-sleep-system__choice").forEach(function (choice) {
      var input = choice.querySelector('input[data-tx-base-check]');
      choice.classList.toggle("is-selected", Boolean(input && input.checked));
    });
  }

  function updatePanel(featured, variant) {
    if (!featured || !variant) return;
    var monthly = featured.querySelector("[data-tx-buy-panel] [data-tx-monthly]");
    if (monthly) monthly.textContent = money(variant.price / 48, "USD");
  }

  function hideEmptyReviews(info) {
    if (!info) return;
    info.querySelectorAll(".t4s-product__review").forEach(function (review) {
      var text = review.textContent.replace(/\s+/g, " ").trim();
      if (/^(no reviews?|0 reviews?)$/i.test(text)) {
        review.hidden = true;
        review.setAttribute("aria-hidden", "true");
      }
    });
    info.querySelectorAll(".jdgm-prev-badge").forEach(function (badge) {
      if (String(badge.getAttribute("data-number-of-reviews") || "") === "0") {
        badge.hidden = true;
        badge.setAttribute("aria-hidden", "true");
        var block = badge.closest(".shopify-app-block");
        if (block) block.classList.add("tx-empty-review-block");
      }
    });
  }

  function enforceHierarchy(info) {
    if (!info) return;
    var price = info.querySelector(".t4s-product__price-review");
    var formBlock = info.querySelector(".t4s-product-form__variants");
    var panel = info.querySelector("[data-tx-buy-panel]");
    if (price && panel && price.parentElement === panel.parentElement && price.nextElementSibling !== panel) {
      price.insertAdjacentElement("afterend", panel);
    }
    var anchor = panel || price;
    var decision = info.querySelector("[data-tx-confidence]");
    if (anchor && decision && anchor.parentElement === decision.parentElement) {
      if (anchor.nextElementSibling !== decision) anchor.insertAdjacentElement("afterend", decision);
      anchor = decision;
    }
    if (anchor && formBlock && anchor.parentElement === formBlock.parentElement && anchor.nextElementSibling !== formBlock) {
      anchor.insertAdjacentElement("afterend", formBlock);
    }
  }

  function optimizeProduct(featured) {
    if (!featured || featured.dataset.txCroReady) return;
    featured.dataset.txCroReady = "true";
    var info = featured.querySelector(".t4s-product__info-container");
    enforceHierarchy(info);
    hideEmptyReviews(info);
    if (info) {
      var reviewObserver = new MutationObserver(function () {
        enforceHierarchy(info);
        hideEmptyReviews(info);
      });
      reviewObserver.observe(info, { childList: true, subtree: true, characterData: true });
      window.setTimeout(function () {
        reviewObserver.disconnect();
      }, 8000);
    }
    var gallery = featured.querySelector("[data-main-media]");
    if (gallery) gallery.setAttribute("aria-label", "Mattress product gallery");
  }

  function init(root) {
    if (!root || root.dataset.txSleepSystemReady) return;
    root.dataset.txSleepSystemReady = "true";
    var form = root.closest('form[action*="/cart/add"]');
    var featured = root.closest("[data-product-featured]");
    var idInput = form && form.querySelector('[name="id"]');
    var mattressVariants = parseJson(root.querySelector("[data-tx-mattress-variants]"));
    var baseVariants = parseJson(root.querySelector("[data-tx-base-variants]"));
    var choices = Array.from(root.querySelectorAll("[data-tx-tier]"));
    var status = root.querySelector("[data-tx-system-status]");
    var total = root.querySelector("[data-tx-system-total]");
    var fit = root.querySelector("[data-tx-best-fit]");
    var activeVariant = null;
    var updateQueued = false;
    var addingBundle = false;
    var matches = {};
    if (!form || !idInput || !choices.length) return;
    var basesByTier = {};
    choices.forEach(function (choice) {
      var tier = choice.dataset.txTier;
      basesByTier[tier] = {};
      (baseVariants[tier] || []).forEach(function (variant) {
        var key = normalizeSize(variant.title);
        if (key) basesByTier[tier][key] = variant;
      });
    });

    function selectedChoice() {
      return choices.find(function (choice) { return choice.querySelector('input[data-tx-base-check]').checked; }) || null;
    }
    function selectedModel(template, choice) {
      return replaceToken(template, "__MODEL__", choice && choice.dataset.model || "");
    }
    function quantity() {
      var field = form.querySelector('[name="quantity"]');
      return Math.max(1, Math.floor(Number(field && field.value) || 1));
    }
    function buttonParts() {
      var button = form.querySelector('button[type="submit"][name="add"]');
      var defaultLabel = button && (button.querySelector(".t4s-btn-atc_text") || button);
      var bundleLabel = button && button.querySelector("[data-tx-bundle-button-label]");
      if (button && !bundleLabel) {
        bundleLabel = document.createElement("span");
        bundleLabel.setAttribute("data-tx-bundle-button-label", "");
        button.appendChild(bundleLabel);
      }
      return { button: button, defaultLabel: defaultLabel, bundleLabel: bundleLabel };
    }
    function updateButton() {
      var choice = selectedChoice();
      var parts = buttonParts();
      if (parts.bundleLabel) parts.bundleLabel.textContent = parts.button.getAttribute("data-tx-atc-label") || selectedModel(root.dataset.bundleButton, choice);
      form.classList.toggle("tx-bundle-selected", Boolean(choice));
    }
    function update() {
      updateQueued = false;
      activeVariant = currentVariant(root, mattressVariants, idInput);
      var size = sizeFromVariant(root, activeVariant);
      var availableCount = 0;
      choices.forEach(function (choice) {
        var tier = choice.dataset.txTier;
        var variant = size.key && basesByTier[tier][size.key] || null;
        var enabled = Boolean(activeVariant && activeVariant.available && variant && variant.available);
        var input = choice.querySelector('input[data-tx-base-check]');
        var price = choice.querySelector("[data-tx-base-price]");
        var compare = choice.querySelector("[data-tx-base-compare]");
        var sizeLabel = choice.querySelector("[data-tx-base-size]");
        if (sizeLabel) sizeLabel.textContent = enabled ? variant.title : "";
        if (compare) {
          compare.hidden = !(enabled && Number(variant.compareAt) > Number(variant.price));
          compare.textContent = compare.hidden ? "" : money(variant.compareAt, root.dataset.currency);
        }
        matches[tier] = enabled ? variant : null;
        input.disabled = !enabled;
        choice.classList.toggle("is-disabled", !enabled);
        choice.setAttribute("aria-disabled", String(!enabled));
        if (enabled) {
          availableCount += 1;
          price.textContent = replaceToken(root.dataset.addPrice, "__PRICE__", money(variant.price, root.dataset.currency));
        } else {
          price.textContent = !size.raw ? root.dataset.chooseSize : variant ? root.dataset.unavailable : root.dataset.notOffered;
        }
        if (input.checked && !enabled) { input.checked = false; }
      });
      var choice = selectedChoice();
      var base = choice && matches[choice.dataset.txTier];
      if (!activeVariant || !size.raw) status.textContent = root.dataset.chooseSize;
      else if (choice && base) status.textContent = replaceToken(selectedModel(root.dataset.selected, choice), "__SIZE__", displaySize(size.key));
      else if (availableCount) status.textContent = replaceToken(root.dataset.supportedSize, "__SIZE__", displaySize(size.key));
      else status.textContent = replaceToken(root.dataset.unsupportedSize, "__SIZE__", size.raw);
      var cents = (Number(activeVariant && activeVariant.price) || 0) + (Number(base && base.price) || 0);
      total.hidden = !base;
      total.textContent = base ? replaceToken(root.dataset.total, "__PRICE__", money(cents * quantity(), root.dataset.currency)) : "";
      if (fit) fit.hidden = !(base && choice.dataset.txTier === "best");
      root.dataset.txSystemPrice = String(cents);
      setChoiceState(root);
      updateButton();
      updatePanel(featured, activeVariant && {price: cents});
    }
    function queueUpdate() {
      if (updateQueued || addingBundle) return;
      updateQueued = true;
      window.requestAnimationFrame(update);
    }
    root.addEventListener("change", function (event) {
      if (event.target.matches("[data-tx-base-check]") && event.target.checked) {
        choices.forEach(function (choice) {
          var input = choice.querySelector("[data-tx-base-check]");
          if (input !== event.target) input.checked = false;
        });
      }
      update();
    });
    form.addEventListener("change", queueUpdate);
    form.addEventListener("input", queueUpdate);
    new MutationObserver(queueUpdate).observe(form, {attributes: true, subtree: true, attributeFilter: ["class", "selected", "value"]});
    form.addEventListener("submit", function (event) {
      var requestedChoice = selectedChoice();
      if (!requestedChoice) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (addingBundle) return;
      update();
      var choice = selectedChoice();
      var base = choice && matches[choice.dataset.txTier];
      if (!activeVariant || !activeVariant.available || !base || choice !== requestedChoice) {
        status.textContent = root.dataset.error;
        return;
      }
      var parts = buttonParts();
      addingBundle = true;
      if (parts.button) { parts.button.disabled = true; parts.button.setAttribute("aria-busy", "true"); }
      if (parts.bundleLabel) parts.bundleLabel.textContent = selectedModel(root.dataset.addingButton, choice);
      var formData = new FormData(form);
      var properties = {};
      formData.forEach(function (value, key) {
        var property = key.match(/^properties\[(.+)\]$/);
        if (property && typeof value === "string" && value) properties[property[1]] = value;
      });
      properties[root.dataset.propertyLabel] = replaceToken(selectedModel(root.dataset.propertyValue, choice), "__TIER__", choice.dataset.tierLabel);
      var mattressItem = {id: Number(activeVariant.id), quantity: quantity(), properties: properties};
      var sellingPlan = formData.get("selling_plan");
      if (sellingPlan) mattressItem.selling_plan = Number(sellingPlan);
      var baseItem = {id: Number(base.id), quantity: quantity(), properties: {"_Paired mattress": String(activeVariant.id)}};
      var addUrl = String(root.dataset.addUrl || "/cart/add").replace(/\.js$/, "").replace(/\/$/, "") + ".js";
      fetch(addUrl, {method: "POST", credentials: "same-origin", headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify({items: [mattressItem, baseItem]})})
        .then(function (response) { return response.json().then(function (body) { if (!response.ok) throw new Error(body.description || body.message || root.dataset.error); return body; }); })
        .then(function () { window.location.assign(root.dataset.cartUrl || "/cart"); })
        .catch(function (error) {
          addingBundle = false;
          if (parts.button) { parts.button.disabled = false; parts.button.removeAttribute("aria-busy"); }
          updateButton();
          status.textContent = error.message || root.dataset.error;
        });
    }, true);
    form.addEventListener("click", function (event) {
      var button = event.target.closest('button[type="submit"][name="add"]');
      if (!button || button.form !== form || !selectedChoice()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!addingBundle && !button.disabled) form.requestSubmit(button);
    }, true);
    optimizeProduct(featured);
    update();
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-tx-sleep-system]").forEach(init);
    (scope || document).querySelectorAll("[data-product-featured]").forEach(optimizeProduct);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();




